import { useState } from 'react';

/** Addresses shown before the rest fold behind "N more" — an org-wide send can be long. */
const VISIBLE = 3;

/**
 * "Will be emailed to", from the backend's `previewQuoteRecipients`. Used by the
 * client-contacts section and the send dialog.
 *
 * `nominated` only picks the wording: the addresses are the backend's either way.
 */
export function QuoteRecipientsLine({
	loading,
	failed,
	emails,
	nominated,
	listIgnored,
}: {
	loading: boolean;
	failed: boolean;
	emails?: string[];
	nominated?: boolean;
	/** Contacts are chosen but none still qualifies, so it fell back to everyone. */
	listIgnored?: boolean;
}) {
	const [expanded, setExpanded] = useState(false);

	if (loading) return <span>Checking who will be emailed…</span>;
	// An error is not an empty list — say we don't know rather than "nobody".
	if (failed || !emails) return <span>Couldn’t check who will be emailed right now.</span>;

	if (emails.length === 0) {
		return <span className="text-status-warn">Nobody will be emailed.</span>;
	}

	const shown = expanded ? emails : emails.slice(0, VISIBLE);
	const rest = emails.length - shown.length;

	return (
		<span>
			{listIgnored && (
				<span className="text-status-warn">
					None of the chosen contacts can be emailed any more, so everyone at the client
					is.{' '}
				</span>
			)}
			{nominated === false && !listIgnored
				? 'Will be emailed to everyone at the client: '
				: 'Will be emailed to '}
			<span className="text-text-2">{shown.join(', ')}</span>
			{rest > 0 && (
				<>
					{' '}
					<button
						type="button"
						className="text-text-2 underline underline-offset-2"
						onClick={() => setExpanded(true)}
					>
						and {rest} more
					</button>
				</>
			)}
			{expanded && emails.length > VISIBLE && (
				<>
					{' '}
					<button
						type="button"
						className="text-text-3 underline underline-offset-2"
						onClick={() => setExpanded(false)}
					>
						Show less
					</button>
				</>
			)}
		</span>
	);
}
